/**
 * i18n bootstrap.
 *
 * Defaults to English (the project's primary documentation + launch
 * audience).  Detects browser language on first load — if the user's
 * browser is set to es-* we switch to Spanish.  After the first
 * explicit toggle, the choice is persisted in localStorage and wins
 * over browser detection.
 *
 * Math notation (KaTeX strings, formula labels like "M", "a/M", "Q",
 * "ds²", "T_H") is intentionally NOT translated — the symbols are
 * the universal physics language.  We translate prose around them.
 */

import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import en from './locales/en.json'
import es from './locales/es.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'es'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'spacetime-lab-lang',
    },
  })

export default i18n
